import { Component, OnInit } from '@angular/core';

import { SelectItem } from 'primeng/api';
import Swal from 'sweetalert2';
import { ssApiService } from 'app/services/ss-api.service';
import { IBaseResponse } from 'app/models/comm-http/responses/BaseResponse';
import { CreditCardResponseArray } from 'app/models/ss-api/responses/credit.card.response';
import { InvoiceItem } from '../../models/ss-api/responses/invoice.item';
import { PayInvoiceRequest } from '../../models/ss-api/requests/pay.invoice.request';
import { DecimalPipe } from '@angular/common';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface IPayInvoiceDialogModel {
    title: string;
    subTitle: string;
    CreditCards: SelectItem[];
    Invoice: InvoiceItem;
}

@Component({
    selector: 'pay-invoice-dialog',
    styleUrls: ['./pay-invoice-dialog.component.scss'],
    templateUrl: './pay-invoice-dialog.component.html',
    providers: [DecimalPipe],
})
export class PayInvoiceDialogComponent implements IPayInvoiceDialogModel, OnInit {

    IsBusy: boolean = false;

    confirmTitle: string = 'Purchase GIS Bundle?';
    confirmMessage: string = 'You are about to purchase a GIS bundle. Your credit card will be billed.';

    successTitle: string = 'GIS Bundle Purchased';
    successMessage: string = 'Your purchase was successfull. The GIS credits are added to your account.';

    errorTitle: string = 'Error';
    errorMessage: string = 'We were not able to process this request. Try again later or use a different credit card.';

    cancelledTitle: string = 'Cancelled';
    cancelledMessage: string = 'You cancelled this order.';


    title: string;
    subTitle: string;

    CreditCards: SelectItem[];
    SelectedCreditCard: number;

    Invoice: InvoiceItem;

    PurchaseDisabled: boolean = true;

    Credit: number = 0;

    showAddCreditCard: boolean = false;

    result: any;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private api: ssApiService,
        private numberPipe: DecimalPipe
    ) {
    }

    ngOnInit() {
        this.title = this.config.data.title;
        this.subTitle = this.config.data.subTitle;
        this.CreditCards = this.config.data.CreditCards;
        this.Invoice = this.config.data.Invoice;

        this.GetCredit();
        this.SelectedCreditCard = this.CreditCards[0].value;
    }

    close() {
        this.ref.close();
    }

    CreditCardChanged(item: SelectItem) {

    }


    confirm() {
        let request = new PayInvoiceRequest;
        request.CreditCardID = this.SelectedCreditCard;
        request.InvoiceID = this.Invoice.ID;

        this.IsBusy = true;

        Swal.fire({
            title: 'Pay Invoice?',
            text: 'You are about to pay this invoice for $' + this.numberPipe.transform(this.GetPriceDue()) + '. Your selected credit card wil be billed.',
            icon: 'warning',
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // try to order
                return this.api.BillingPayInvoice(request).toPromise();
            }
        }).then((response: any) => {
            this.IsBusy = false;

            if (response.isDismissed) {
                Swal.fire({
                    title: 'Invoice Payment Cancelled!',
                    text: '',
                    icon: 'error',
                    showCancelButton: false,
                    showCloseButton: false,
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    timer: 2000,
                }).then(() => {
    
                }, () => { }); // keep this line to prevent promise error;
                this.IsBusy = false;
                this.close();
            } else if (!response.value || !response.value.Result) {                
                Swal.fire({
                    title: 'Invoice Not Paid!',
                    text: 'There was a problem processing your payment! Please try a different card, or contact our support team at 702-433-0274 or support@structurestudios.com.',
                    icon: 'error',
                    showCancelButton: false,
                    showCloseButton: true,
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                }).then(() => {

                }, () => { }); // keep this line to prevent promise error;
            } else {
                Swal.fire({
                    title: 'Invoice Paid!',
                    text: 'Thank you for your membership!',
                    icon: 'success',
                    showCancelButton: false,
                    showCloseButton: false,
                    allowOutsideClick: false,
                    showLoaderOnConfirm: true,
                    timer: 2000,
                }).then(() => {
                    this.result = true;
                    this.close();
                }, () => {
                    this.result = true;
                    this.close();
                }); // keep this line to prevent promise error;
            }

        }, error => {
            Swal.fire({
                title: 'Invoice Payment Cancelled!',
                text: '',
                icon: 'error',
                showCancelButton: false,
                showCloseButton: false,
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                timer: 2000,
            }).then(() => {

            }, () => { }); // keep this line to prevent promise error;
            this.IsBusy = false;
            this.close();
        });


    }

    cancel() {
        this.result = false;
        this.close();
    }

    cardAdded({cards, newCardId}: {cards: CreditCardResponseArray, newCardId: number}) {
        this.showAddCreditCard = false;
        this.updateCreditCardOptions(cards);
        this.SelectedCreditCard = newCardId;
    }

    addCardCanceled() {
        this.showAddCreditCard = false;
    }

    updateCreditCardOptions(newCards: CreditCardResponseArray) {
        this.CreditCards = [];
        newCards.forEach(card => {
            this.CreditCards.push(
                {
                    label: 'Name: ' + card.FirstName + ' ' + card.LastName +
                        ' - Last four: ' + card.LastFour +
                        ' - exp. Date: ' + card.ExpMonth + '/' + card.ExpYear,
                    value: card.ID
                });
        });
    }


    GetCredit() {
        this.IsBusy = true;

        let subscription = this.api.MemberCredit().subscribe(response => {
            subscription.unsubscribe();
            this.IsBusy = false;
            this.Credit = response.Data;
        }, error => {
            subscription.unsubscribe();
            this.IsBusy = false;
        });

    }

    GetPriceDue(): number {
        let totalPriceDue: number = 0;
        totalPriceDue += this.Invoice.Total;
        totalPriceDue -= this.Credit;
        if (totalPriceDue < 0 || Number.isNaN(totalPriceDue))
            totalPriceDue = 0;

        return totalPriceDue;

    }

    CreditUsed(): number {
        if (this.Credit > this.Invoice.Total)
            return this.Invoice.Total;
        else
            return this.Credit;
    }


}
